import generateConditionLabel from '../Condition/generateConditionLabel';

export default function generateFixedAnswerTreeItemLabel(answerText, exclusionCriteria) {
  return `${answerText}${exclusionCriteria ? ` [Omit if: ${generateConditionLabel(exclusionCriteria)}]` : ''}`;
}
